import { render, staticRenderFns } from "./Locksmith.vue?vue&type=template&id=04b396c2&scoped=true&"
import script from "./Locksmith.vue?vue&type=script&lang=js&"
export * from "./Locksmith.vue?vue&type=script&lang=js&"
import style0 from "./Locksmith.vue?vue&type=style&index=0&id=04b396c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b396c2",
  null
  
)

export default component.exports